// extracted by mini-css-extract-plugin
export var component = "FooterSocial-module--component--af214";
export var fadePop = "FooterSocial-module--fade-pop--505d5";
export var growHeightIn = "FooterSocial-module--grow-height-in--587dd";
export var icon = "FooterSocial-module--icon--078d3";
export var links = "FooterSocial-module--links--0cf3a";
export var socialLink = "FooterSocial-module--socialLink--3fc65";